const columns = [
  {key: 'id', label: 'Name', span: 2},
  {key: 'version', label: 'Version'},
];

export default columns;
